module.exports = __webpack_public_path__ + "img/logo-lockup_Openbay-Lyft.094dc46d.svg";